export { CurrencyPageTemplate } from "./CurrencyPageTemplate";
export { CurrencyPageTemplateOld } from "./CurrencyPageTemplateOld";
export { currencyData } from "./currencyData";
